<template>
    <div></div>
</template>

<script>
import Blank from './Blank.js';
export default Blank;
</script>
